import {
  Directive,
  HostListener,
  Renderer2,
  ElementRef,
  OnInit,
  Inject,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";

@Directive({
  selector: "[appRangeSlider]",
})
export class RangeSliderDirective implements OnInit, OnChanges {
  @Input() total_time: any;
  @Input() total_start_hr: any;
  @Input() total_end_hr: any;
  @Output() leftValue = new EventEmitter();
  @Output() rightValue = new EventEmitter();
  @Output() rangeEditor = new EventEmitter();
  left_thumb_value: any = 0;
  right_thumb_value: any = 0;
  listenerFn = () => {};
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}
  ngOnInit(): void {
    this.elementRef.nativeElement.style.height = "15px";
    this.elementRef.nativeElement.style.backgroundColor = "#fff";
    const rangeEle = this.document.createElement("div");
    rangeEle.style.backgroundColor = "#ccc";
    rangeEle.style.width = "97.5%";
    rangeEle.style.height = "11px";
    rangeEle.style.position = "relative";
    rangeEle.style.top = "13px";
    rangeEle.style.left = "13px";
    rangeEle.style.borderRadius = "5px";
    this.renderer.appendChild(this.elementRef.nativeElement, rangeEle);
    const range_left = this.document.createElement("input");
    this.renderer.setAttribute(range_left, "type", "range");
    this.renderer.setAttribute(range_left, "id", "range_left");
    this.renderer.setAttribute(range_left, "min", "0");
    this.renderer.setAttribute(range_left, "max", this.total_time.toString());
    this.renderer.setAttribute(range_left, "value", "0");
    this.renderer.addClass(range_left, "range_left");
    range_left.style.width = "96.5%";
    range_left.style.webkitAppearance = "none";
    range_left.style.position = "relative";
    range_left.style.top = "-22px";
    range_left.style.height = "0";
    range_left.style.left = "8px";
    this.renderer.appendChild(this.elementRef.nativeElement, range_left);
    
    const range_right = this.document.createElement("input");
    this.renderer.setAttribute(range_right, "type", "range");
    this.renderer.setAttribute(range_right, "id", "range_right");
    this.renderer.setAttribute(range_right, "min", "1");
    this.renderer.setAttribute(range_right, "max", this.total_time.toString());
    this.renderer.setAttribute(
      range_right,
      "value",
      this.total_time.toString()
    );
    this.renderer.addClass(range_right, "range_right");
    range_right.style.width = "96.5%";
    range_right.style.webkitAppearance = "none";
    range_right.style.position = "relative";
    range_right.style.top = "-22px";
    range_right.style.height = "0";
    range_right.style.left = "32px";
    this.renderer.appendChild(this.elementRef.nativeElement, range_right);

    this.renderer.listen(range_left, "input", (event) => {
      this.left_thumb_value = event.target.value;
      // if (this.left_thumb_value + 2 > this.right_thumb_value) {
      // this.left_thumb_value = event.target.value;
      this.leftValue.emit({ value: this.left_thumb_value, mouseEvent: event });
      //   event.preventDefault();
      //   return false;
      // }
    });
    this.renderer.listen(range_right, "input", (event) => {
      this.right_thumb_value = event.target.value;
      // if (this.right_thumb_value - 2 < this.left_thumb_value) {
      // this.right_thumb_value = event.target.value;
      this.rightValue.emit({
        value: this.right_thumb_value,
        mouseEvent: event,
      });
      // event.preventDefault();
      // return false;
      // }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.total_start_hr?.currentValue) {
      let leftElem = this.document.getElementById('range_left');
      leftElem?.setAttribute('value', changes?.total_start_hr['currentValue']);
    }
    if(changes?.total_end_hr?.currentValue) {
      let rightElem = this.document.getElementById('range_right');
      rightElem?.setAttribute('value', changes?.total_end_hr['currentValue']);
    }
  }

  onStartTimeChange(data) {
    
  }

  @HostListener("dblclick", ["$event"]) onDblClick(event) {}

  addCommonStyle(ele, pos) {
    ele.style.width = "20px";
    ele.style.height = "20px";
    ele.style.display = "inline-block";
    ele.style.backgroundColor = "orangered";
    ele.style.borderRadius = "10px";
    ele.style.position = "relative";
    ele.style.top = "-8px";
    ele.style.cursor = "pointer";
    ele.style.left = pos + "%";
  }
}
